// import { convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import type { Props } from './rich-text'
import './rich-text.scss'

const RichText = ({
  desktop,
  mobile,
  content,
  marginTop,
  marginBottom,
}: Props) => {
  // const parsedContent = convertFromRaw(JSON.parse(content))
  // const result = draftToHtml(convertToRaw(parsedContent))
  const result = draftToHtml(JSON.parse(content))
  const { lessDesktop } = useBreakpoint()
  const deviceData = lessDesktop ? mobile : desktop

  return (
    <div
      style={{
        marginTop: `${marginTop ?? ' '}`,
        marginBottom: `${marginBottom ?? ' '}`,
      }}
      className={`${deviceData?.marginRichText?.richtext} rich-text-component`}
      dangerouslySetInnerHTML={{ __html: result }}
    />
  )
}

export default RichText
